import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { nl } from './translations/nl';

i18n.use(initReactI18next).init({
  fallbackLng: 'nl',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    nl,
  },
});

export default i18n;
